// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recon-root {
  width: 100%;
}
.recon-root-container {
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  width: 100%;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/PaymentReconciliation/recon.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,WAAW;EACX,cAAc;AAChB","sourcesContent":[".recon-root {\n  width: 100%;\n}\n.recon-root-container {\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  width: 100%;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
